'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _actionsVideoRoom = require('../actions/videoRoom');
function videoRoom(state, action) {
  if (state === undefined) state = {
    feeds: []
  };
  switch (action.type) {
    case _actionsVideoRoom.ROOM_LOCAL_FEED:
    case _actionsVideoRoom.ROOM_REMOTE_FEED:
      var feed = action.feed,
        feeds = action.feeds;
      return Object.assign({}, state, {
        addedFeed: feed,
        feeds: feeds
      });
    case _actionsVideoRoom.ROOM_LOCAL_STREAM:
    case _actionsVideoRoom.ROOM_REMOTE_STREAM:
      var feed = action.feed,
        feeds = action.feeds;
      return Object.assign({}, state, {
        streamFeed: feed,
        feeds: feeds
      });
    case _actionsVideoRoom.ROOM_REMOVE_FEED:
      var feed = action.feed,
        feeds = action.feeds;
      return Object.assign({}, state, {
        removedFeed: feed,
        feeds: feeds
      });
    case _actionsVideoRoom.AUDIO_DISABLED:
      return Object.assign({}, state, {
        audioDisabled: true
      });
    case _actionsVideoRoom.ATTACH_MCU_ERROR:
    case _actionsVideoRoom.ROOM_EXISTS_ERROR:
    case _actionsVideoRoom.CREATE_ROOM_ERROR:
    case _actionsVideoRoom.ROOM_LOCAL_FEED_ERROR:
    case _actionsVideoRoom.ROOM_REMOTE_FEED_ERROR:
    case _actionsVideoRoom.ROOM_ICE_ERROR:
    case _actionsVideoRoom.ROOM_LOCAL_DATA_ERROR:
      return Object.assign({}, state, {
        error: action
      });
    default:
      return state;
  }
}
exports['default'] = {
  videoRoom: videoRoom
};
module.exports = exports['default'];